export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
}
